export const headertitle = {
    BLOG: "blog",
    TESTIMONIAL: "testimonial"
}